import { useTranslation } from 'react-i18next';
import React, { useMemo } from 'react';
import { MultiDropdownFieldAllSelected, TDropdownOption } from '@payler/ui-components';
import { TNotificationKind } from '../../../../../api/src';

export const ALL_TRIGGER_VALUES: TNotificationKind[] = [
  'Block',
  'Unblock',
  'Refund',
  'Charge',
  'Repeatpay',
  'Credit',
  'Receipt',
  'Check',
  'Declined',
  'CardSaved',
];

export const Triggers = () => {
  const { t } = useTranslation(['notifications']);
  const options = useTriggerOptions();

  return (
    <MultiDropdownFieldAllSelected
      fieldName="triggers"
      label={t('notifications:triggers')}
      options={options}
      selectAllLabel={t('notifications:allTriggers')}
      preset="mc1"
      hideClearButton
      nullValueAsAllSelected
      selectAllOptionsBehaviour="selected"
      showSelectAllLabelAsValue
    />
  );
};

const useTriggerOptions = (): TDropdownOption[] => {
  const { t } = useTranslation(['notificationKind']);
  return useMemo(
    () =>
      ALL_TRIGGER_VALUES.map((value) => ({
        value,
        label: t(`notificationKind:${value}`),
      })),
    [t],
  );
};
